import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Row, Col, Drawer, Divider, TreeSelect } from 'antd';
import BaseRadioList from '@/components/Elements/BaseRadios';
import { isMobile } from 'react-device-detect';
import { _newLine, makeTree } from '@/utils/helpers';
import { createCustomerCareCategory, updateCustomerCareCategory, getCustomerCareCategoryActive } from '@/redux/actions/customerCareCategoryActions';

class CustomerCareCategoryForm extends Component {
    constructor() {
        super();
        this.state = {
            loadingForm: false,
        };
    }

    componentDidMount() {
        this.props.getCustomerCareCategoryActive();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentItem != this.props.currentItem) {

        }
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            delete values.documents;

            if (!err) {
                try {
                    this.setState({ loadingForm: true })
                    console.log('values: ', values)

                    if (this.props.currentItem) {
                        await this.props.updateCustomerCareCategory(this.props.currentItem.id, values);
                        //this.onClose();
                    } else {
                        await this.props.createCustomerCareCategory(values);
                        //this.onClose();
                    }
                    this.props.form.resetFields();
                    this.setState({
                        loadingForm: false
                    })
                    this.props.reloadData();
                    this.props.getCustomerCareCategoryActive();
                } catch (error) {
                    this.setState({ loadingForm: false });
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({
            loadingForm: false
        })
    }

    render() {
        var { loadingForm } = this.state;
        var { visible, currentItem, customerCareCategoryActiveList } = this.props;
        const { getFieldDecorator } = this.props.form;
        const listParentTree = makeTree(customerCareCategoryActiveList || [], 0);

        console.log('currentItem: ', currentItem)

        return (
            <Drawer
                visible={visible}
                title={currentItem ? "Sửa danh mục CSKH" : "Thêm một danh mục CSKH"}
                onOk={(e) => this.submit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '60%'}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => this.onClose()}>
                            Huỷ
                        </Button>
                        <Divider type="vertical" />
                        <Button loading={loadingForm} key="submit" type="primary" onClick={(e) => this.submit(e)}>
                            {currentItem ? "Cập nhật" : "Thêm mới"}
                        </Button>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item label="Tên danh mục">
                                    {getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.name : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Parent">
                                    {getFieldDecorator('parent_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.parent_id : 0
                                    })(
                                        <TreeSelect
                                            style={{ width: '100%' }}
                                            dropdownStyle={{ maxHeight: 450, overflow: 'auto' }}
                                            treeData={listParentTree || []}
                                            showSearch
                                            multiple={false}
                                            treeNodeFilterProp='title'
                                            allowClear
                                            placeholder="Chọn một bản ghi"
                                            treeDefaultExpandAll
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Mô tả chi tiết">
                                    {getFieldDecorator('description', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.description) : null
                                    })(
                                        <Input.TextArea rows={5} placeholder="Nhập mô tả chi tiết" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.note) : null
                                    })(
                                        <Input.TextArea />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Trạng thái">
                                    {getFieldDecorator('status', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.status : 1
                                    })(
                                        <BaseRadioList
                                            options={[
                                                { label: "Active", value: 1 },
                                                { label: "Inactive", value: 0 }
                                            ]}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        customerCareCategoryActiveList: state.customerCareCategoryReducer.customerCareCategoryActiveList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createCustomerCareCategory: (data) => dispatch(createCustomerCareCategory(data)),
        updateCustomerCareCategory: (id, data) => dispatch(updateCustomerCareCategory(id, data)),
        getCustomerCareCategoryActive: () => dispatch(getCustomerCareCategoryActive()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerCareCategoryForm' })(CustomerCareCategoryForm));
